import {useTranslation} from "react-i18next";
import {useForm, Yup} from "../forms/form";
import {Button, Form} from "react-bootstrap";
import {FormGroup} from "../components";
import React, {useEffect, useState} from "react";
import BoolSelect from "../forms/inputs/BoolSelect";
import Block, {Section} from "../Block";
import {useFormattedLanguage} from "../utils";
import ShowItem from "../ShowItem";


export default function PurposeForm({purpose, setSubmitButtonProps, onSubmit, languages = [], params}) {
  const { t } = useTranslation();

  const [editable, setEditable] = useState(true)
  const formatLanguage = useFormattedLanguage(t)

  useEffect(() => {
    purpose && setEditable(purpose.editable)
  }, [purpose])

  const initialValues = {
    legInt: '',
    key: '',
    content: []
  };

  const validationSchema = Yup.object().shape({
    legInt: Yup.boolean().required(),
    key: Yup.string()
  })

  const { getInputProps, formProps, formData, handleInputChange } = useForm({
    defaultObject: purpose,
    initialValues: initialValues,
    validationSchema: validationSchema,
    setSubmitButtonProps: setSubmitButtonProps,
    onSubmit: onSubmit,
  });


  return <Form {...formProps}>
    {(!purpose || purpose.type == 'purpose') && purpose?.iabId != 1 && <FormGroup input={BoolSelect} label={t("cmp.legIntAllowed")} {...getInputProps("legInt")} />}
    {!purpose?.iabId && <FormGroup input="text" label={t("cmp.vendors.key")} {...getInputProps("key")}/>}
    {languages.map(language => {
      return <Block key={language} title={formatLanguage(language)}>
        {['name', 'description', 'descriptionLegal'].map(attributeName => {
          return <FormGroup input={"textarea"}
                            key={attributeName}
                            rows={attributeName != 'name' ? 6 : 1}
                            label={t(`cmp.${attributeName}`)}
                            name={`${language}.${attributeName}`}
                            onChange={(v) => {
                              const filtered = formData.content.filter(el => el.language != language || el.name != attributeName)
                              handleInputChange([...filtered, {language: language, name: attributeName, content: v.target.value}], 'content')
                            }}
                            disabled={!editable}
                            value={formData.content.find(el => el.language == language && el.name == attributeName)?.content || ""}/>
        })}
      </Block>
    })}
  </Form>

}
